import { render } from "./TransferTotals.vue?vue&type=template&id=5d71f8a9"
import script from "./TransferTotals.vue?vue&type=script&lang=js"
export * from "./TransferTotals.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__